module.exports = __webpack_public_path__ + "static/media/pastoral-team-cover.0ab739a2.png";